import React from 'react';
import { sanitizeString } from '../utils/security';

const safe = (v) => sanitizeString(v ?? '');

const formatDate = (value) => {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  } catch {
    return '—';
  }
};

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', gap: '12px', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
    <div style={{ flex: '0 0 140px', fontSize: '13px', fontWeight: 600, color: '#475569' }}>{label}</div>
    <div style={{ flex: 1, fontSize: '14px', color: '#1f2937', wordBreak: 'break-word' }}>{value || '—'}</div>
  </div>
);

const SmsNetgsmDetayModal = ({ sms, onClose }) => {
  if (!sms) return null;

  const jobId = sms.netgsmJobId || sms.hariciSmsId;
  const detayJson = sms.netgsmDetay
    ? JSON.stringify(sms.netgsmDetay, null, 2)
    : null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '720px', width: '95%', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}
      >
        <div className="modal-header" style={{ flexShrink: 0 }}>
          <h2>
            <i className="fas fa-info-circle" style={{ marginRight: 8, color: '#2563eb' }} />
            NetGSM Detayı
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="modal-body" style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
          <Row label="Telefon" value={safe(sms.telefon)} />
          <Row label="Gönderim" value={safe(sms.durumText || sms.durum)} />
          <Row label="Teslim" value={safe(sms.teslimDurumuText || sms.teslimDurumu)} />
          <Row label="Job ID" value={jobId || '—'} />
          <Row label="API Kodu" value={safe(sms.netgsmKod)} />
          <Row label="Açıklama" value={safe(sms.netgsmAciklama)} />
          <Row label="Teslim Tarihi" value={formatDate(sms.teslimTarihi)} />
          <Row label="Son Sorgu" value={formatDate(sms.teslimSorguTarihi)} />
          {sms.hataMesaji && <Row label="Hata" value={safe(sms.hataMesaji)} />}

          {detayJson ? (
            <div style={{ marginTop: '16px' }}>
              <div style={{ fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '8px' }}>
                Ham yanıt
              </div>
              <pre
                style={{
                  margin: 0,
                  padding: '12px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '8px',
                  fontSize: '12px',
                  lineHeight: 1.5,
                  overflow: 'auto',
                  maxHeight: '280px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {detayJson}
              </pre>
            </div>
          ) : (
            <p style={{ marginTop: '16px', color: '#64748b', fontSize: '14px' }}>
              NetGSM kaydı yok (eski kayıt veya API çağrılmadı).
            </p>
          )}
        </div>
        <div className="modal-footer" style={{ flexShrink: 0 }}>
          <button type="button" className="secondary-btn" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsNetgsmDetayModal;
